<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="760" persistent>
      <v-card class="nc-card" tile>
        <v-card-title class="nc-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-account-plus</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">{{ editando ? 'Editar contacto' : 'Nuevo contacto' }}</div>
              <div class="text-body-2 white--text">{{ editando ? 'Modifica los datos del contacto' : 'Registra un contacto y conviértelo en prospecto' }}</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <timelineProgreso ref="reftimelineProgreso"/>
          <v-divider class="mt-0" />  

          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                label="* Nombres"
                v-model.trim="nombres"
                outlined
                dense
                type="text"
                prepend-inner-icon="mdi-account"
                placeholder="Ej. Ana Maria"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="* Apellidos"
                v-model.trim="apellidos"
                outlined
                dense
                type="text"
                prepend-inner-icon="mdi-account"
                placeholder="Ej. Perez Lopez"
              />
            </v-col>
            <v-col cols="12">
              <v-select
                v-model="origen"
                :items="origenes"
                :loading="isloadingestudent"
                item-text="nombre"
                return-object
                label="* Origen del contacto"
                loader-height="6"
                outlined
                dense
                prepend-inner-icon="mdi-source-branch"
                class="origen-contacto-select"
              >
                <template v-slot:selection="{ item }">
                  <div class="origen-contacto-selection">
                    <span class="origen-contacto-name">{{ origenNombre(item) }}</span>
                    <span v-if="origenDescripcion(item)" class="origen-contacto-description">
                      {{ origenDescripcion(item) }}
                    </span>
                  </div>
                </template>
                <template v-slot:item="{ item }">
                  <div class="origen-contacto-item">
                    <div class="origen-contacto-number">{{ origenNumero(item) }}</div>
                    <div class="origen-contacto-content">
                      <div class="origen-contacto-name">{{ origenNombre(item) }}</div>
                      <div v-if="origenDescripcion(item)" class="origen-contacto-description">
                        {{ origenDescripcion(item) }}
                      </div>
                    </div>
                  </div>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="area"
                :items="areas"
                :loading="isloadingestudent"
                item-text="nombre"
                return-object
                label="* Area de interes"
                loader-height="6"
                outlined
                dense
                prepend-inner-icon="mdi-target"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="* Teléfono"
                v-model="telefono"
                outlined
                dense
                type="text"
                prepend-inner-icon="mdi-phone"
                placeholder="Ej. 70012345"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Correo (opcional)"
                v-model="correo"
                outlined
                dense
                type="email"
                prepend-inner-icon="mdi-email"
                placeholder="Ej. correo@ejemplo.com"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                v-model="profesionNombre"
                :items="listaProfesiones"
                item-text="nombre"
                label="* Profesión"
                outlined
                dense
                prepend-inner-icon="mdi-briefcase"
                :loading="isLoadingProfesiones"
                clearable
                hide-no-data
                placeholder="Escribe para buscar..."
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                  type="date" 
                  v-model="fecha_de_contacto"
                  label="* fecha de contacto"
                  :max="fechaHoy()"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="filtroprograma"
                label="Programa de interés (opcional)"
                outlined
                dense
                prepend-inner-icon="mdi-school"
                placeholder="Describe el programa de interés..."
                :counter="256"
                maxlength="256"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">
            Cerrar
          </v-btn>
          <v-btn color="green" class="white--text text-none" :loading="loading" outlined :disabled="loading" @click="enviar()">
            <v-icon left small>mdi-check</v-icon>
            {{ editando ? 'Guardar cambios' : 'Registrar contacto' }}
          </v-btn>
          <v-btn v-if="!editando" color="green" class="white--text text-none" outlined :loading="loading" :disabled="loading" @click="enviar(true)">
            <v-icon left small>mdi-check</v-icon>
            Registrar y Prospectar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="false"><ABuscarPersona ref="abuscarpersona" /></div>
  </div>
</template>

<script>
  import timelineProgreso from './timeline-progreso.vue';
  import ABuscarPersona from '@/components/ABuscarPersona';
  import gql from 'graphql-tag';
  import { getOrigenesContacto, getAreas, createContacto, updateContacto } from './utils';

  export default {
    components: {
      ABuscarPersona,
      timelineProgreso
    },
    data() {
      return {
        loading: true,
        dialog: false,
        editando: false,
        editId: null,
        isloadingestudent: false,
        filtroprograma: '',
        estudiantes: [],
        filtroestudiante: null,
        origenes: [],
        origen: null,
        areas: [],
        area: null,
        profesionNombre: null,
        listaProfesiones: [],
        isLoadingProfesiones: false,
        timeoutHnd: 0,
        nombres: '',
        apellidos: '',
        telefono: '',
        correo: '',
        fecha_de_contacto: null,
        new_contacto: {},
      };
    },
    computed: {},
    watch: {
      filtroestudiante: function () {
        if (typeof this.filtroestudiante == 'object') {
          this.setEstudianteSel();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function () {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      async openmodal(contacto = null) {
        this.new_contacto = {};
        this.filtroestudiante = null;
        this.origen = null;
        this.area = null;
        this.profesionNombre = null;
        this.filtroprograma = '';
        this.nombres = contacto ? contacto.nombres || '' : '';
        this.apellidos = contacto ? contacto.apellidos || '' : '';
        this.telefono = contacto ? contacto.telefono || '' : '';
        this.correo = contacto ? contacto.correo || '' : '';
        this.fecha_de_contacto = contacto ? this.parseFecha(contacto.fecha_de_contacto) || null : null;
        this.editando = !!contacto;
        this.editId = contacto ? contacto.id : null;
        this.loading = true;
        this.dialog = true;
        
        this.$nextTick(() => {
          this.$refs.reftimelineProgreso.iniciar(-1, false); 
        }); 

        await Promise.all([this.findOrigenes(), this.findAreas(), this.loadProfesiones()]);

        if (contacto) {
          this.filtroprograma = contacto.programa_interes_name || '';
          this.origen = this.origenes.find(o => String(o.id) === String(contacto.origen_id)) || null;
          this.area = this.areas.find(a => String(a.id) === String(contacto.area_interes_id)) || null;
          const profMatch = contacto.profesion_name
            ? this.listaProfesiones.find(p => p.nombre.toLowerCase() === contacto.profesion_name.toLowerCase()) || contacto.profesion_name
            : null;
          this.profesionNombre = profMatch;
        }

        this.loading = false;
      },
      cerrar() {
        this.dialog = false;
      },
      async findOrigenes() {
        const res = await getOrigenesContacto();
        this.origenes = res;
      },
      origenNombre(item) {
        return item && typeof item === 'object' ? item.nombre : item;
      },
      origenDescripcion(item) {
        return item && typeof item === 'object' ? item.descripcion : '';
      },
      origenNumero(item) {
        const index = this.origenes.indexOf(item);
        return index >= 0 ? index + 1 : '';
      },
      normalizarSeleccion(item, items) {
        if (item && typeof item === 'object') return item;
        return items.find(i => String(i.nombre) === String(item)) || null;
      },
      async findAreas() {
        const u = this.$store.state.CARGO.sede.unidad_negocio;
        const res = await getAreas(this, u);
        const ids_permitidos = [10,12,6,1,4, 77,79,80,82,88, 62,64,66,70,72]
        this.areas = res.getAreas
          .filter(x => ids_permitidos.includes(x.id))
          .map(x => ({
            ...x,
            nombre: x.nombre.toUpperCase(),
          }));
      },
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      setEstudianteSel() {
        if(!this.filtroestudiante) return;

        
        const fil = this.filtroestudiante;
        if (!fil.seg_apellido) fil.seg_apellido = '';
        
        const name = `${fil.nombres} ${fil.pri_apellido} ${fil.seg_apellido}`.trim();
        

        this.new_contacto.persona_id = fil.id;
        this.new_contacto.persona_name = name;
        
      },
      parseFecha(f){
        const fs = f.split('T')[0]
        return fs
      },
      fechaHoy() {
        return new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000).toISOString().substring(0, 10);
      },
      async enviar(open_prospectar_after = false) {
        if(!this.nombres){
          this.$root.$notify.show('escriba los nombres', { color: 'red', x: 'right' });
          return;
        }
        if(!this.apellidos){
          this.$root.$notify.show('escriba los apellidos', { color: 'red', x: 'right' });
          return;
        }
        if(!this.telefono){
          this.$root.$notify.show('escriba el teléfono', { color: 'red', x: 'right' });
          return;
        }
        if(!this.fecha_de_contacto){
          this.$root.$notify.show('ingrese la fecha cuando fue contactado', { color: 'red', x: 'right' });
          return;
        }
        if(this.fecha_de_contacto > this.fechaHoy()){
          this.$root.$notify.show('la fecha de contacto no puede ser superior al dia de hoy', { color: 'red', x: 'right' });
          return;
        }

        if(!this.origen){
          this.$root.$notify.show('selecione el origen', { color: 'red', x: 'right' });
          return;
        }
        if(!this.area){
          this.$root.$notify.show('selecione la area', { color: 'red', x: 'right' });
          return;
        }
        if(!this.profesionNombre){
          this.$root.$notify.show('escriba la profesión', { color: 'red', x: 'right' });
          return;
        }

        const us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        const us_name = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();
        this.new_contacto.asesor_id = us.id;
        this.new_contacto.asesor_name = us_name;
        this.new_contacto.estado = 'activo';

        const areaSeleccionada = this.normalizarSeleccion(this.area, this.areas);
        if (!areaSeleccionada || !areaSeleccionada.id) {
          this.$root.$notify.show('selecione una area valida', { color: 'red', x: 'right' });
          return;
        }

        this.new_contacto.origen_id = this.origen.id;
        this.new_contacto.area_interes_id = areaSeleccionada.id;
        this.new_contacto.area_interes_name = areaSeleccionada.nombre;
        const profVal = this.profesionNombre;
        this.new_contacto.profesion_name = typeof profVal === 'object' ? (profVal ? profVal.nombre : '') : (profVal || '');
        this.new_contacto.nombres = this.nombres;
        this.new_contacto.apellidos = this.apellidos;
        this.new_contacto.telefono = this.telefono;
        this.new_contacto.correo = this.correo;
        this.new_contacto.fecha_de_contacto = this.fecha_de_contacto;
        this.new_contacto.programa_interes_name = this.filtroprograma || '';

        let res;
        this.loading = true;
        if (this.editando) {
          res = await updateContacto({
            id: this.editId,
            nombres: this.new_contacto.nombres,
            apellidos: this.new_contacto.apellidos,
            telefono: this.new_contacto.telefono,
            origen_id: this.new_contacto.origen_id,
            area_interes_id: this.new_contacto.area_interes_id,
            area_interes_name: this.new_contacto.area_interes_name,
            profesion_name: this.new_contacto.profesion_name,
            fecha_de_contacto: this.new_contacto.fecha_de_contacto,
            estado: 'ACTIVO',
          });
        } else {
          res = await createContacto(this.new_contacto);
        }

        this.loading = false;

        if (res && res.id) {
          this.$root.$notify.show(this.editando ? 'Contacto actualizado' : 'registrado :)', { color: 'green', x: 'right' });
          const open_prospectar_data = {
            open_prospectar_after: open_prospectar_after,
            contacto_id: res.id
          }
          this.$emit('onsuccess',open_prospectar_data);
          this.cerrar();
        } else if (res && res.error) {
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        } else {
          this.$root.$notify.show('algo salio mal :)', { color: 'red', x: 'right' });
        }

        
      },
      async loadProfesiones() {
        if (this.listaProfesiones.length) return;
        this.isLoadingProfesiones = true;
        const sql = gql`query{ getProfesiones(estado:true){ id, nombre } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          this.listaProfesiones = r && r.getProfesiones ? r.getProfesiones : [];
        } catch (e) {
          window.console.error(e);
          this.listaProfesiones = [];
        } finally {
          this.isLoadingProfesiones = false;
        }
      },
    },
    mounted(){}
  };
</script>

<style scoped>
.nc-card {
  border-radius: 14px;
  overflow: hidden;
}
.nc-hero {
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
.origen-contacto-select {
  text-align: left;
}
.origen-contacto-selection {
  display: flex;
  min-width: 0;
  max-width: 100%;
  flex-direction: column;
  line-height: 1.25;
}
.origen-contacto-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
  max-width: 100%;
  width: 100%;
  padding: 10px 0 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  line-height: 1.25;
  white-space: normal;
}
.origen-contacto-item .origen-contacto-name {
  margin-bottom: 4px;
}
.origen-contacto-number {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: rgba(255, 106, 0, 0.12);
  color: #d84315;
  font-size: 12px;
  font-weight: 700;
}
.origen-contacto-content {
  min-width: 0;
  flex: 1;
}
.origen-contacto-name {
  font-weight: 600;
  color: rgba(0, 0, 0, 0.87);
}
.origen-contacto-description {
  display: -webkit-box;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  line-height: 1.35;
  -webkit-box-orient: vertical;
  /* -webkit-line-clamp: 2; */
}
.origen-contacto-selection .origen-contacto-description {
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>
